// Stat-tile values are read at a glance, so they compact once the digit count
// stops being scannable.
export function compactNumber(n: number): string {
  if (n < 10000) return n.toLocaleString('en-GB');
  return `${(n / 1000).toFixed(1)}K`;
}

export function percent(value: number | null): string {
  if (value === null || value === undefined) return '—';
  return `${(value * 100).toFixed(1)}%`;
}
